import { MagazineHero, FeaturedIssue, MagazineArchive } from '@/components/sections/magazine-page'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const MagazinePage = () => {
  usePageTitle('Magazine')

  return (
    <>
      <MagazineHero />
      <FeaturedIssue />
      <MagazineArchive />
      <FinalCTA />
    </>
  )
}
